export default {
  dbi_filter_modal_tips: '提示',
  dbi_filter_modal_ok: '好的',
  dbi_filter_modal_cancel: '取消',
  dbi_filter_modal_no_longer_prompt: '不再提示',
  dbi_filter_modal_content:
    '存在当前时间/国家筛选器粒度下不适用的已选指标。如需查看数据，请参考数据源说明，切换为指标有效时间/国家粒度。点击撤销会重置时间和国家筛选器到上一次筛选项。',
};
